///<reference path="SegmentFilter.d.ts"/>


import './SegmentFilter.less'
import { proto_watch, subscriptionCallback, handler_SegmentApply, setValidationProps, segmentTypes, newSegment, newDataPointCondition } from './SegmentFilter.service'

// utils
import { uid, debounce, rs_observer } from '@utils/Misc'


// type overrides
interface SegmentFilter {
    $refs: {
        [k: string]: HTMLElement & HTMLInputElement
    }
}



class BaseSegmentFilter {

    cid = uid()

    callback = subscriptionCallback.bind(this)
    segment: KnockoutObservable<ko_Segment> = ko.observable({
        SegmentDefinition: <ko_SegmentGroup>newSegment('SegmentGroup', this.callback)
    })

    segmentGroup = ko.pureComputed(() => this.segment().SegmentDefinition)

    // For property segments
    segmentProperties: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    contactRelativeSegmentProperty: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    dataPointDataType: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    //contactFields: any
    contactRelativeSegmentOperators: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    propertyOperators: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    eventParticipantStatuses: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    interactionTypes: KnockoutObservableArray<NameValuePair> = ko.observableArray([])   
    // For recipient segments
    recipientOperators: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    smsRecipientOperators: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    // For member segments
    memberOperators: KnockoutObservableArray<NameValuePair> = ko.observableArray([])    
    IssueRecipientLimiterTimeSpan: KnockoutObservableArray<NameValuePair> = ko.observableArray([])
    contactCount: KnockoutObservable<number> = ko.observable(0)


    segmentDataPromise: PromiseLike<any[]>
    getSegmentData() {
        this.segmentDataPromise = Promise.all([

            !!this.segmentProperties().length
            || $.fn.application.get('/Segments/Properties').then(this.segmentProperties),
            !!this.contactRelativeSegmentProperty().length
            || $.fn.application.get('/Segments/ContactRelativeDateProperty').then(this.contactRelativeSegmentProperty),
            !!this.dataPointDataType().length
            || $.fn.application.get('/Segments/DataPointDataType').then(this.dataPointDataType),
            !!this.contactRelativeSegmentOperators().length
            || $.fn.application.get('/Segments/ContactRelativeDateOperators').then(this.contactRelativeSegmentOperators),
            !!this.propertyOperators().length
            || $.fn.application.get('/Segments/PropertyOperators').then(this.propertyOperators),

            $.fn.application.get('/Segments/RecipientOperators').then(this.recipientOperators),
            $.fn.application.get('/Segments/SmsRecipientOperators').then(this.smsRecipientOperators),
            $.fn.application.get('/Segments/MemberOperators').then(this.memberOperators),
            $.fn.application.get('/Segments/IssueRecipientLimiterTimeSpan').then(this.IssueRecipientLimiterTimeSpan),
            $.fn.application.get('/Segments/EventParticipantStatuses').then(this.eventParticipantStatuses),
            $.fn.application.get('/Segments/InteractionTypes').then(this.interactionTypes)
        ])
    }

    applyProcessor = (segment: any) => {
        const pw_processor = (segment: ko_AnySegment_Inter, ctx: any) => {
            setValidationProps(segment as ko_AnySegment_Inter)
            proto_watch(segment, subscriptionCallback.bind(ctx), handler_SegmentApply, ctx)
        }

        this.validateFromRoot(true, segment, pw_processor)

        return segment
    }

    getSegment(segmentId: string) {

        $.fn.application.get('/Segments/' + segmentId)
            .then((segment: any) => {

                let seg = ko.mapping.fromJS(segment)

                this.segment(this.applyProcessor(seg))
            })
    }


    deleteEmpty: boolean = false
    namespace: string
    rootContainer: HTMLElement = null

    //**  _CONSTRUCTOR
    constructor(params: BaseSegmentFilterParams = {}) {
        this.namespace = params.namespace || 'global'

        this.getSegmentData()

        this.setParams(params)

        if (subscriptions[this.cid + 'rs'])
            subscriptions[this.cid + 'rs'].dispose()

        subscriptions[this.cid + 'rs'] = this.segment().SegmentDefinition.Segments.subscribe((segments: ko_AnySegment_Union[]) => {
            if (this.deleteEmpty && segments.length > 0 && !this.segmentId())
                this.createRootSegment()
        })
    }

    segmentId = ko.observable<string>()
    autoCollapseAt: number = 0 // < 0: dont autocollapse
    rootCollapsed = false
    owner: {
        ObjectId: null,
        OwnedByRelation: null
    }
    name = ko.observable<string>()
    async setParams(params: BaseSegmentFilterParams | any = {}) {

        // skip fetching same data if it's supplied
        // to the first instance of base
        if (!this.segmentProperties().length && params.properties)
            this.segmentProperties(params.properties())

        if (!this.propertyOperators().length && params.propertyOperators)
            this.propertyOperators(params.propertyOperators())

        if (!this.contactRelativeSegmentProperty().length && params.contactRelativeSegmentProperty)
            this.contactRelativeSegmentProperty(params.contactRelativeSegmentProperty())

        if (!this.dataPointDataType().length && params.dataPointDataType)
            this.dataPointDataType(params.dataPointDataType())
        
        if (!this.contactRelativeSegmentOperators().length && params.contactRelativeSegmentOperators)
            this.contactRelativeSegmentOperators(params.contactRelativeSegmentOperators())
        
        await this.segmentDataPromise

        if (params.beforeSave)
            params.beforeSave[this.cid] = this.save

        if (params.segment) {
            this.segmentId = params.segment.SegmentId

            this.segment(this.applyProcessor(params.segment))
        }
        else if (params.segmentId) {
            this.segmentId = params.segmentId

            if (params.segmentId())
                this.getSegment(params.segmentId())
        }

        if (params.name)
            this.name = params.name

        if (params.owner)
            this.owner = params.owner()

        if (params.deleteEmpty)
            this.deleteEmpty = params.deleteEmpty

        if (params.autoCollapseAt) {
            this.autoCollapseAt = params.autoCollapseAt
            this.rootCollapsed = this.segment().SegmentDefinition.Segments().length >= this.autoCollapseAt ? true : false
        }

        if (params.rootCollapsed) {
            this.rootCollapsed = ko.unwrap(params.rootCollapsed)
        }

        if (params.validate)
            params.validate.push(this.validateFromRoot)
    }


    createRootSegment = () => {
        $.fn.application.post('/Segments/' + `?name=${this.name()}&objectId=${this.owner.ObjectId}&relation=${this.owner.OwnedByRelation}`)
            .then((result: any) => {
                this.segmentId(result.SegmentId)
                result.Name = this.name()
                result.OwnedByObjectId = this.owner?.ObjectId || null
                result.OwnedByRelation = this.owner?.OwnedByRelation || null
                result = ko.mapping.fromJS(result)
                result.SegmentDefinition = this.segment().SegmentDefinition

                this.segment(result)
            })
    }


    updateSegment = () => {
        $.fn.application.post('/Segments/' + this.segmentId(), ko.mapping.toJSON(this.segment, { ignore: ['dispose', 'watcher'] }))
    }

    deleteSegment = () => {
        let toDelete = ko.mapping.toJS([this.segment])
        this.segmentId(null)

        $.fn.application.delete('/Segments', { '': toDelete })
            .then(() => {
                console.log('segment filter deleted')
            })
    }



    save = () => {
        let segments_len = this.segment().SegmentDefinition.Segments().length
        if (this.deleteEmpty && segments_len === 0) {
            this.segmentId() &&
                this.deleteSegment()
            return true
        }

        let [isValid] = this.validateFromRoot()
        if (isValid && this.segmentId())
            this.updateSegment()

        return isValid
    }



    previewCount = () => {
        this.validateFromRoot()
        //$.fn.application.get('/Segments/CountIssueRecipients' + '?issueId=' + this.owner.ObjectId)
        //    .then((result: number) => {
        //        this.contactCount(result)
        //        console.log('iiiiiiii', result)
        //    })
    }

    showInvalid = ko.observable(false)
    validateFromRoot = (quiet: boolean = false, segment: ko_Segment = this.segment(), processor: Func = () => { }) => {
        let allOk = true, len = 0

        const traverse = (segments: ko_AnySegment_Union[]) => {
            len += segments.length

            for (let segment of segments) {

                processor(segment, segments)

                if (segment.Type() === 'SegmentGroup')
                    traverse((<ko_SegmentGroup>segment).Segments())

                else
                    for (let prop in segment) {
                        if (typeof segment[prop].validate === 'function') {
                            let valid = segment[prop].validate()
                            allOk &&= valid
                        }
                    }
            }
        }

        traverse(segment.SegmentDefinition.Segments())
        this.rootCollapsed = this.autoCollapseAt > 0 && this.autoCollapseAt < len

        !quiet && this.showInvalid(!allOk)

        return [allOk, len]
    }
}








export const subscriptions: any = {},
    instances: {
        [k: string]: BaseSegmentFilter
    } = {},
    setBase = (params: any = {}) => {
        let base = instances[params.namespace || 'global'] ||= new BaseSegmentFilter(params)

        base
            ? base.setParams(params)  // set or add params from all instances (TODO: filter)
            : base = new BaseSegmentFilter(params)

        return base
    }





class SegmentFilter {

    cid = uid()
    base: BaseSegmentFilter

    level: number = -1

    segmentGroup: KnockoutObservable<ko_SegmentGroup> = ko.observable()


    conditionCount = ko.pureComputed(() => {

        this.conditionCount.old = this.conditionCount.cur || 0
        this.conditionCount.cur = this.segmentGroup().Segments().length || 0

        return this.conditionCount.cur
    }) as KnockoutComputed<number> & { old: number, cur: number }


    setCustomProperty = (val: number = this.conditionCount.cur) => {
        requestAnimationFrame(() => {
            let height = val === 0
                ? (this.level && this.$refs.info.offsetHeight)
                : this.collapsed()
                    ? this.$refs.info.offsetHeight
                    : this.$refs.wrapper.offsetHeight

            this.$refs.root.style.setProperty('--sb-max-height', height + 'px')
        })
    }


    setupDomRefs: any = (name: string, el: HTMLElement & { setCustomProperty: () => void }) => {

        if (this.level === 0 && name === 'root')
            this.base.rootContainer = el.parentElement

        if (name === 'wrapper') {
            el.setCustomProperty = this.setCustomProperty
            rs_observer.observe(el)
        }
    }


    collapsed = ko.observable(false)
    toggleCollapse = () => {

        this.setCustomProperty()
        this.collapsed(!this.collapsed())
    }


    //**  _CONSTRUCTOR
    constructor(params: SegmentFilterParams) {

        this.base = setBase(params)

        this.level = (params.level ?? -1) + 1

        this.level <= 0 &&
            this.collapsed(params.rootCollapsed ? ko.unwrap(params.rootCollapsed) : this.base.rootCollapsed)

        if (params.segmentGroup)
            this.segmentGroup(ko.unwrap(params.segmentGroup))
        else {
            if (subscriptions[this.base.cid])
                subscriptions[this.base.cid].dispose()

            this.segmentGroup(this.base.segmentGroup())
            subscriptions[this.base.cid] = this.base.segmentGroup.subscribe((val: any) => {

                this.segmentGroup(val)

                this.collapsed(this.level <= 0 ? ko.unwrap(params.rootCollapsed) : this.base.rootCollapsed)
            })
        }
    }


    removeSegment = (segment: ko_AnySegment_Union | any, context: any) => {

        segment.dispose()
        context.segmentGroup().Segments.remove(segment)
    }

    addDataPointCondition = (dataPointSegment: any) => {
        dataPointSegment.Conditions.push(newDataPointCondition())
    }

    removeDataPointCondition = (dataPointSegment: any, condition: any) => {
        dataPointSegment.Conditions.remove(condition)
    }
}





class SegmentFilterDropdown {

    cid = uid()
    base: BaseSegmentFilter
    segmentGroup: KnockoutObservable<ko_SegmentGroup> = ko.observable()
    segmentTypes = segmentTypes


    //**  _CONSTRUCTOR
    constructor(params: any) {

        this.base = setBase(params)
        this.segmentGroup(ko.unwrap(params.segmentGroup))
    }

    addSegment = (segmentType: string) => {

        let group = this.segmentGroup() ? this.segmentGroup() : this.base.segmentGroup()
        group.Segments.push(newSegment(segmentType, this.base.callback, this.segmentGroup()))
    }
}





ko.components.register('segment-filter', {
    viewModel: SegmentFilter,
    template: { path: 'App/Shared/SegmentFilter/SegmentFilter' }
})

ko.components.register('segment-filter-dropdown', {
    viewModel: { useSlots: SegmentFilterDropdown },
    template: { path: 'App/Shared/SegmentFilter/SegmentFilterDropdown' }
})
